import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import MobileMiniPlayer from './MobileMiniPlayer';
import './MobileHeader.css';

const HamburgerIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

function MobileHeader({ onJobsClick }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <header className="mobile-header">
        <span className="mobile-header-logo">ferl</span>
        <MobileMiniPlayer />
        <button
          type="button"
          className="mobile-header-hamburger"
          onClick={() => setMenuOpen(true)}
          aria-label="Open menu"
        >
          <HamburgerIcon />
        </button>
      </header>

      {menuOpen && (
        <div
          className="mobile-header-overlay"
          role="dialog"
          aria-modal="true"
          aria-label="Navigation menu"
        >
          <div className="mobile-header-overlay-inner">
            <button
              type="button"
              className="mobile-header-close"
              onClick={closeMenu}
              aria-label="Close menu"
            >
              <CloseIcon />
            </button>
            <nav className="mobile-header-nav">
              <NavLink
                to="/jobs"
                onClick={() => { closeMenu(); onJobsClick?.(); }}
              >
                JOBS
              </NavLink>
              <NavLink to="/music/playlist" onClick={closeMenu}>MUSIC</NavLink>
              <NavLink to="/markets" onClick={closeMenu}>MARKETS</NavLink>
              <NavLink to="/account" onClick={closeMenu}>ACCOUNT</NavLink>
            </nav>
          </div>
          <div
            className="mobile-header-backdrop"
            onClick={closeMenu}
            aria-hidden="true"
          />
        </div>
      )}
    </>
  );
}

export default MobileHeader;
